import React from "react";
import { get } from "lodash";

import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";
import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";
import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";
import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";

const BG_COLOR = "white";

const SliceStructure = ({ doc, StartOrderBtn }) => {
  const { text, internal_link_id, description } = doc.primary || {};

  return (
    <div className="container pb-md-3 pb-2xl-3 pb-4 large-cta-slice-container">
      {internal_link_id && (
        <span id={internal_link_id} className="scroll-point position-relative d-block" />
      )}
      {checkContentPresence(text) && (
        <div className="text-white sns-h3 large-cta-slice-title">{textResolver(text)}</div>
      )}
      {checkContentPresence(description) && (
        <div className="sns-h5 buttons-block-description pt-3 pt-2xl-3 large-cta-slice-description">
          {textResolver(description)}
        </div>
      )}
      <div className="start-an-order-home-btn row align-items-center justify-content-center pt-3 pt-2xl-3">
        {get(doc, "primary.enable_start_order") && StartOrderBtn && (
          <div className="col-md-6 my-md-3 my-2xl-3 my-1">
            <StartOrderBtn className="button button-program-green btn btn-block font-weight-bold">
              Send A Treat
            </StartOrderBtn>
          </div>
        )}
        {get(doc, "items", []).map((link, idx) => {
          const url = get(link, "url.url");
          const urlText = get(link, "link_text");
          const btnClass = link?.transparent_button
            ? "button-program-outline-green"
            : "button-program-green";

          if (url) {
            return (
              <div
                className="col-md-6 my-md-3 my-2xl-3 my-1 large-cta-slice-buttons-column"
                key={`program-link-${idx}`}
              >
                <PrismicLinkTag
                  urlText={urlText}
                  url={url}
                  target={get(link, "url.target")}
                  className={`button font-weight-bold btn btn-block m-auto ${btnClass}`}
                />
              </div>
            );
          }
        })}
      </div>
    </div>
  );
};

const ButtonsBlock = ({ doc, StartOrderBtn }) => {
  const { text, bg_image, mobile_img, bg_color = BG_COLOR } = doc.primary || {};
  const imageUrl = bg_image?.url;
  const imageAlt = bg_image?.alt;
  const mobileImageUrl = mobile_img?.url;
  const mobileImageAlt = mobile_img?.alt;
  const webSectionColor = { backgroundColor: bg_color };
  const mobileSectionColor = { backgroundColor: bg_color };

  return (
    <div
      className={`buttons-block text-center large-cta-slice ${
        checkContentPresence(text) && "button-section-title"
      }`}
    >
      <div className="large-cta-slice-holder d-none d-md-block" style={webSectionColor}>
        {imageUrl && (
          <div className="large-cta-primary-image-holder">
            <PrismicImgix
              className="large-cta-primary-image"
              src={imageUrl}
              alt={imageAlt}
              desktop="1440px"
              mobile="500px"
              tablet="1000px"
              largeDisplay="5000px"
            />
          </div>
        )}
        <SliceStructure doc={doc} StartOrderBtn={StartOrderBtn} />
      </div>

      <div className="large-cta-slice-holder d-md-none" style={mobileSectionColor}>
        {mobileImageUrl && (
          <div className="large-cta-primary-image-holder">
            <PrismicImgix
              className="large-cta-primary-image"
              src={mobileImageUrl}
              alt={mobileImageAlt}
              desktop="500px"
              mobile="500px"
              tablet="500px"
              largeDisplay="500px"
            />
          </div>
        )}
        <SliceStructure doc={doc} StartOrderBtn={StartOrderBtn} />
      </div>
    </div>
  );
};

export default ButtonsBlock;
